import styled from 'styled-components';

type Props = {
  lines: number;
};

// Note that this also works in Firefox even though the prefix is `-webkit-`
// https://developer.mozilla.org/en-US/docs/Web/CSS/-webkit-line-clamp
export const LineClamp = styled.div<Props>`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: ${({ lines }) => lines};
  overflow: hidden;
  word-break: ${({ lines }) => (lines === 1 ? 'break-all' : undefined)};
`;
